import { useState, useEffect, useCallback } from 'react';
import { getScopeSummary as fetchScopeSummary } from '../../carbonApi';

const useScopeSummary = (scopeType = "scope 2", fyid, locationIds = [], categories = []) => {
  const [scopeData, setScopeData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Stable primitive keys so the effect only re-runs when the selection changes.
  const locationKey = (locationIds || []).join(",");
  const categoryKey = (categories || []).join(",");

  const getScopeSummary = useCallback(async () => {
    // Summary is scoped to the FY the page has selected; skip until it's known.
    if (!fyid) return;
    setLoading(true);
    setError(null);

    try {
      const { isSuccess, data } = await fetchScopeSummary({
        scope: scopeType,
        fyid,
        locationIds: locationKey ? locationKey.split(",") : [],
        categories: categoryKey ? categoryKey.split(",") : [],
      });

      if (isSuccess) {
        setScopeData(data);
      } else {
        setError("Failed to fetch scope data");
      }
    } catch (err) {
      console.error("❌ API ERROR:", err);
      setError(err.message || "An unexpected error occurred");
    } finally {
      setLoading(false);
    }
  }, [scopeType, fyid, locationKey, categoryKey]);

  useEffect(() => {
    getScopeSummary();
  }, [getScopeSummary]);

  // Return the data, loading state, error, and a refresh function
  return { scopeData, loading, error, refresh: getScopeSummary };
};

export default useScopeSummary;

